import React, { useState } from "react";
import "../components/StpBan.css";
import STPVIDEO from "../images/videos/VIDEOS/VID1.mp4";

export default function StpBan() {

  const phone = "919597839564";

  const [showForm, setShowForm] = useState(false);
  const [org, setOrg] = useState("");
  const [address, setAddress] = useState("");
  const [mobile, setMobile] = useState("");
  const [method, setMethod] = useState("");
  const [query, setQuery] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!org || !mobile || !method) {
      alert("Please fill required fields");
      return;
    }

    const message = encodeURIComponent(
      `STP Installation Enquiry\n\n` +
      `Organization: ${org}\n` +
      `Address: ${address}\n` +
      `Phone: ${mobile}\n\n` +
      `Installation Method:\n${method}\n\n` +
      `Service Details:\n${query}`
    );

    window.open(`https://wa.me/${phone}?text=${message}`, "_blank");
  };

  return (
    <>
      {/* HERO */}
      <section className="hero">
        <video
          className="hero-video"
          src={STPVIDEO}
          autoPlay
          loop
          muted
          playsInline
        />
        <div className="hero-overlay"></div>

        <div className="hero-content">
          <div className="title-box">
            <h1>Sewage Treatment Plant</h1>
            <button className="quote-btn" onClick={() => setShowForm(true)}>
              Get Quote
            </button>
          </div>
        </div>
      </section>

      {/* STP FORM */}
      {showForm && (
        <div className="stp-modal">
          <div className="stp-form">
            <h2>STP Installation</h2>

            <form onSubmit={handleSubmit}>
              <label>
                Name of the Organization:
                <input
                  type="text"
                  value={org}
                  onChange={(e) => setOrg(e.target.value)}
                />
              </label>

              <label>
                Address:
                <input
                  type="text"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
              </label>

              <label>
                Phone:
                <input
                  type="tel"
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value)}
                />
              </label>

              <div className="stp-section">
                <p className="section-title">STP INSTALLATION METHODS</p>

                <label className="radio-line">
                  <input
                    type="radio"
                    name="method"
                    value="Engineering Method"
                    onChange={(e) => setMethod(e.target.value)}
                  />
                  Engineering Method
                </label>

                <label className="radio-line">
                  <input
                    type="radio"
                    name="method"
                    value="Pre-Fabricated Method"
                    onChange={(e) => setMethod(e.target.value)}
                  />
                  Pre-Fabricated Method
                </label>
              </div>

              <div className="stp-section">
                <p className="section-title">STP SERVICE</p>
                <p className="note">
                  We do all the sewage treatment plant service works.
                  Please write your query detail below.
                </p>

                <textarea
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                />
              </div>

              <div className="stp-actions">
                <button type="submit" className="send-btn">
                  Send via WhatsApp
                </button>
                <button
                  type="button"
                  className="cancel-btn"
                  onClick={() => setShowForm(false)}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}